import React from 'react';

const AutoHyperLinkText = ({ text }) => {
  if (typeof text !== 'string') return null; // safeguard

  const urlRegex = /https?:\/\/[^\s]+/g;
  const parts = text.split(urlRegex);
  const urls = text.match(urlRegex) || [];

  const cleanUrl = (url) => url.replace(/[.,!?]+$/, '');

  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {index < urls.length && (
            <a
              href={cleanUrl(urls[index])}
              target="_blank"
              rel="noopener noreferrer"
            >
              {cleanUrl(urls[index])}
            </a>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default AutoHyperLinkText;
